import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { EventService } from '@event/event.service';
import { Ad6SelectComponent } from '@library/form/select.component';
import { Ad6Option } from '@library/shared/option';
import { TranslatePipe } from '@ngx-translate/core';
import { forkJoin, Subscription } from 'rxjs';

@Component({
  selector: 'ad6-event-selector',
  templateUrl: './event-selector.component.html',
  styleUrls: ['./event-selector.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    Ad6SelectComponent,
    TranslatePipe,
  ],
  standalone: true,
})
export class EventSelectorComponent implements OnInit, OnDestroy {
  eventService = inject(EventService);

  selectEventForm!: FormGroup;
  eventListOptions!: Ad6Option[];

  private eventSelectionValueChanged?: Subscription;

  ngOnInit(): void {
    forkJoin({
      activeEvent: this.eventService.getActive(),
      events: this.eventService.getList(),
    }).subscribe(({ activeEvent, events }) => {
      this.eventListOptions = events.map(event => ({
        id: event.uuid,
        description: event.name,
      }));

      this.selectEventForm = new FormGroup({
        selectedEvent: new FormControl({
          value: activeEvent?.uuid ?? this.eventListOptions[0].id,
          disabled: events.length === 1,
        }),
      });

      this.eventSelectionValueChanged = this.selectEventForm
        .get('selectedEvent')
        ?.valueChanges.subscribe((eventUuid: string) => {
          this.onEventChanged(eventUuid);
        });
    });
  }

  ngOnDestroy(): void {
    this.eventSelectionValueChanged?.unsubscribe();
  }

  private onEventChanged(eventUuid: string): void {
    this.eventService.setEvent(eventUuid);
  }
}
